import { api } from "../..";

export const resetPassword = async (
  password: string,
  newPassword: string,
  token: string | null
) => {
  const response = await api.post(
    `/reset-password?token=${token}`,
    {
      novaSenha: password,
      novaSenhaConfirmacao: newPassword,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
